module.exports = __webpack_public_path__ + "img/yonghuzhan.736c4044.png";